export type ReasoningLoadError = 'forbidden' | 'failed';

const reasoningLoadErrorCopy: Record<ReasoningLoadError, string> = {
  forbidden: "You don't have access to AI scoring data.",
  failed: "Couldn't load the AI reasoning. Close and try again.",
};

export const classifyLoadError = (err: unknown): ReasoningLoadError =>
  (err as { statusCode?: number } | null | undefined)?.statusCode === 403 ? 'forbidden' : 'failed';

export const reasoningLoadErrorMessage = (error: ReasoningLoadError): string => reasoningLoadErrorCopy[error];
